import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import css from "./annualReport.module.css";
var ProductNumberStatsTable = function (_a) {
    var stats = _a.stats, locale = _a.locale;
    var rows = [
        {
            labelId: "ui-br-agency.outputs.annual-report.label.books",
            value: stats.books,
        },
        {
            labelId: "ui-br-agency.outputs.annual-report.label.ebooks",
            value: stats.ebooks,
        },
        {
            labelId: "ui-br-agency.outputs.annual-report.label.audiobooks",
            value: stats.audiobooks,
        },
        {
            labelId: "ui-br-agency.outputs.annual-report.label.eAudiobooks",
            value: stats.eaudiobooks,
        },
        {
            labelId: "ui-br-agency.outputs.annual-report.label.printedMusic",
            value: stats.printedMusic,
        },
        {
            labelId: "ui-br-agency.outputs.annual-report.label.eMusic",
            value: stats.emusic,
        },
    ];
    return (React.createElement("table", { className: css.resultsTable },
        React.createElement("thead", null,
            React.createElement("tr", null,
                React.createElement("th", null,
                    React.createElement(FormattedMessage, { id: "ui-br-agency.outputs.annual-report.label.category" })),
                React.createElement("th", null,
                    React.createElement(FormattedMessage, { id: "ui-br-agency.outputs.annual-report.label.count" })))),
        React.createElement("tbody", null, rows.map(function (row) { return (React.createElement("tr", { key: row.labelId },
            React.createElement("td", null,
                React.createElement(FormattedMessage, { id: row.labelId })),
            React.createElement("td", null, row.value.toLocaleString(locale)))); }))));
};
export var AnnualReportResults = function (_a) {
    var data = _a.data;
    var _b = useIntl(), locale = _b.locale, formatMessage = _b.formatMessage;
    return (React.createElement("div", { className: css.resultsContainer },
        React.createElement("h3", null,
            React.createElement(FormattedMessage, { id: "ui-br-agency.outputs.annual-report.section.publishers" })),
        React.createElement("table", { className: css.resultsTable },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", { "aria-label": formatMessage({
                            id: "ui-br-agency.outputs.annual-report.section.publishers",
                        }) }),
                    React.createElement("th", null,
                        React.createElement(FormattedMessage, { id: "ui-br-agency.outputs.annual-report.label.isbn" })),
                    React.createElement("th", null,
                        React.createElement(FormattedMessage, { id: "ui-br-agency.outputs.annual-report.label.ismn" })))),
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement(FormattedMessage, { id: "ui-br-agency.outputs.annual-report.label.newPublishers" })),
                    React.createElement("td", null, data.newPublishersIsbn.toLocaleString(locale)),
                    React.createElement("td", null, data.newPublishersIsmn.toLocaleString(locale))),
                React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement(FormattedMessage, { id: "ui-br-agency.outputs.annual-report.label.totalPublishers" })),
                    React.createElement("td", null, data.totalPublishersIsbn.toLocaleString(locale)),
                    React.createElement("td", null, data.totalPublishersIsmn.toLocaleString(locale))))),
        React.createElement("h3", null,
            React.createElement(FormattedMessage, { id: "ui-br-agency.outputs.annual-report.section.assignedMiscellaneous" })),
        React.createElement(ProductNumberStatsTable, { stats: data.assignedFromMiscellaneous, locale: locale }),
        React.createElement("h3", null,
            React.createElement(FormattedMessage, { id: "ui-br-agency.outputs.annual-report.section.reportedRegistered" })),
        React.createElement(ProductNumberStatsTable, { stats: data.reportedFromRegistered, locale: locale })));
};
